import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { BsInstagram, BsWhatsapp } from "react-icons/bs";

const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-[#C60302] text-white font-montserrat relative z-50">
      {/* --- BARIS ATAS: LOGO & MENU NAVIGASI --- */}
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-[100px]">
        <div className="flex flex-col md:flex-row justify-between items-center py-6 sm:py-7 gap-5 md:gap-0">
          {/* Logo Brand Fluenesia */}
          <Link 
            to="/" 
            className="inline-block transition-transform duration-200 hover:scale-105"
            aria-label="Fluenesia Home"
          >
            <img
              src="/Fluenesia-white.png"
              alt="Fluenesia Logo"
              className="h-6 sm:h-7 w-auto object-contain"
            />
          </Link>

          {/* Menu Navigasi Sesuai Figma */}
          <nav className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 text-[14px] md:text-[15px] font-semibold tracking-normal">
            <Link
              to="/about"
              className="text-white hover:text-white/80 transition-colors duration-200"
            >
              About
            </Link>
            <Link
              to="/program-selection"
              className="text-white hover:text-white/80 transition-colors duration-200"
            >
              Program
            </Link>
            <Link
              to="/Trial/TrialClass"
              className="text-white hover:text-white/80 transition-colors duration-200"
            >
              Register Class
            </Link>
            <Link
              to="/Future/FutureMentor"
              className="text-white hover:text-white/80 transition-colors duration-200"
            >
              Future Mentor
            </Link>
          </nav>
        </div>
      </div>

      {/* --- GARIS PEMISAH (DIVIDER) --- */}
      <div className="w-full border-t border-white/20"></div>

      {/* --- BARIS BAWAH: LEGALITAS & KONTAK SOSMED --- */}
      <div className="max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-[100px]">
        <div className="flex flex-col md:flex-row justify-between items-center py-4 gap-4">
          {/* Legalitas PT & Kemenkumham */}
          <p className="text-xs md:text-[13px] font-normal text-white/90 text-center md:text-left tracking-normal leading-relaxed">
            PT. Ankara Gala Wisesa (Studyfirst) – Nomor Izin Kemenkumham: 1110230126914
          </p>

          {/* Kontak & Media Sosial */}
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-7">
            {/* WhatsApp / Call Center */}
            <a
              href="https://wa.me/6282324433012"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp Call Center"
              className="flex items-center gap-2 text-white hover:text-white/80 transition-colors duration-200 group text-xs md:text-[13px] font-medium"
            >
              <BsWhatsapp className="w-4 h-4 md:w-[18px] md:h-[18px] flex-shrink-0 transition-transform duration-200 group-hover:scale-110" />
              <span>Call Center</span>
            </a>

            {/* Email */}
            <a
              href="mailto:fluenesia@gmail.com"
              aria-label="Email Fluenesia"
              className="flex items-center gap-2 text-white hover:text-white/80 transition-colors duration-200 group text-xs md:text-[13px] font-medium"
            >
              <Mail className="w-4 h-4 md:w-[18px] md:h-[18px] flex-shrink-0 transition-transform duration-200 group-hover:scale-110" />
              <span>fluenesia@gmail.com</span>
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/fluenesia.id"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram Fluenesia"
              className="flex items-center gap-2 text-white hover:text-white/80 transition-colors duration-200 group text-xs md:text-[13px] font-medium"
            >
              <BsInstagram className="w-4 h-4 md:w-[18px] md:h-[18px] flex-shrink-0 transition-transform duration-200 group-hover:scale-110" />
              <span>Instagram</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
